import { Injectable } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";
import { StateService } from "./state.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DatadogRumService {
  constructor(private stateService: StateService) {
    const domainType = this.stateService.checkAppConfig();
    if (environment.production && domainType !== "pho") {
      datadogRum.init({
        applicationId: "6b853a76-e65c-44d2-a6aa-0367a57c68ef",
        clientToken: "pub7a9513b275bc270790b5d39c0fcea2b9",
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: "datadoghq.com",
        service: "catexpert.ai",
        env: "prod",
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: "mask-user-input",
      });

      datadogRum.startSessionReplayRecording();
    }
  }

  // Helper method to set the user data to datadog
  setUser() {
    // Retrieve user data from localStorage
    const user = this.stateService.getUser();
    if (user) {
      // Set user details in Datadog RUM
      datadogRum.setUser({
        id: user.id,
        name: user.first_name,
        email: user.email,
        role: user.role,
      });
    }
  }
}
